// extracted by mini-css-extract-plugin
export default {"description":"DescriptionBox_description__Hw4VV","descriptionText":"DescriptionBox_descriptionText__Br-KR"};